import api from "./client";

export interface NotificationSettings {
  sms_enabled: boolean;
  sms_confirmation_enabled: boolean;
  sms_reminder_enabled: boolean;
  sms_cancellation_enabled: boolean;
  sms_waitlist_availability_enabled: boolean;

  email_confirmation_enabled: boolean;
  email_reminder_enabled: boolean;
  email_cancellation_enabled: boolean;
  email_waitlist_availability_enabled: boolean;

  reminder_primary_hours: number;
  reminder_secondary_hours: number | null;
  reminder_secondary_enabled: boolean;
}

export type SmsAllowanceStatus =
  | "available"
  | "exhausted"
  | "unlimited"
  | "not_included"
  | "unavailable";

export interface SmsAllowance {
  allowed: boolean;
  limit: number | null;
  used: number | null;
  remaining: number | null;
  reset_at: string | null;
  status: SmsAllowanceStatus;
  message: string | null;
}

export interface NotificationChannelCapability {
  email_supported: boolean;
  sms_supported: boolean;
}

export type NotificationCapabilities = Record<
  | "booking_confirmation"
  | "booking_reminder"
  | "booking_cancellation"
  | "waitlist_availability",
  NotificationChannelCapability
>;

export interface NotificationSettingsResponse {
  settings: NotificationSettings;
  sms_allowance: SmsAllowance;
  capabilities: NotificationCapabilities;
}

export type UpdateNotificationSettingsPayload = Partial<NotificationSettings>;

function normalizeSettings(settings: NotificationSettings): NotificationSettings {
  return {
    ...settings,
    reminder_primary_hours:
      settings.reminder_primary_hours != null
        ? Number(settings.reminder_primary_hours)
        : 24,
    reminder_secondary_hours:
      settings.reminder_secondary_hours != null
        ? Number(settings.reminder_secondary_hours)
        : null,
  };
}

export async function fetchNotificationSettings(): Promise<NotificationSettingsResponse> {
  const res = await api.get("/notifications/settings");
  const data = res.data;

  return {
    ...data,
    settings: normalizeSettings(data.settings),
  };
}

export async function updateNotificationSettings(
  payload: UpdateNotificationSettingsPayload
): Promise<void> {
  await api.put("/notifications/settings", payload);
}
